module.exports = __webpack_public_path__ + "static/webbPurp-d3fa821ab64ae5f9e4b23b9df0b3d89e.png";